import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { shippingMethodsClient } from "@core/clients";
import { Address, TTaxiShippingQuote } from "@core/types";

type Params = {
  customerAddress: Address;
};

type Options = UseMutationOptions<TTaxiShippingQuote | null, Error, Params>;

export const useCalculateTaxiShippingMutation = (options?: Options) => {
  return useMutation<TTaxiShippingQuote | null, Error, Params>({
    mutationKey: ["calculate-shipping"],
    mutationFn: async ({ customerAddress }) => {
      return await shippingMethodsClient.calculateTaxiShipping(customerAddress);
    },
    ...options,
  });
};
